import EntryActionTypes from '../constants/EntryActionTypes';

const fetchContentViewPlansInCurrentBoard = (pointSystemId = null) => ({
  type: EntryActionTypes.CONTENT_VIEW_PLANS_IN_CURRENT_BOARD_FETCH,
  payload: {
    pointSystemId,
  },
});

const getOrCreateContentViewPlanInCurrentBoard = (
  year,
  month,
  pointSystemId = null,
  values = null,
) => ({
  type: EntryActionTypes.CONTENT_VIEW_PLAN_IN_CURRENT_BOARD_GET_OR_CREATE,
  payload: {
    year,
    month,
    pointSystemId,
    values,
  },
});

const updateContentViewPlan = (id, data) => ({
  type: EntryActionTypes.CONTENT_VIEW_PLAN_UPDATE,
  payload: {
    id,
    data,
  },
});

export default {
  fetchContentViewPlansInCurrentBoard,
  getOrCreateContentViewPlanInCurrentBoard,
  updateContentViewPlan,
};

